/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BasicListEnrichmentItemCountDto } from './BasicListEnrichmentItemCountDto';
import type { BasicListItemPreviewDto } from './BasicListItemPreviewDto';
import type { CrmConnectionsStatusDto } from './CrmConnectionsStatusDto';
import type { ListColumnDto } from './ListColumnDto';
export type BasicListWithColumnsAndConnectionsAndEnrichmentCountDto = {
    enrichment_item_count: BasicListEnrichmentItemCountDto | null;
    crm_connections: CrmConnectionsStatusDto;
    columns: Array<ListColumnDto>;
    id: string;
    name: string;
    type: BasicListWithColumnsAndConnectionsAndEnrichmentCountDto.type;
    item_count: number;
    date: string;
    last_item_update: string;
    unmatched_item_count: number;
    show_unmatched_items_notice: boolean;
    preview_items: Array<BasicListItemPreviewDto>;
};
export namespace BasicListWithColumnsAndConnectionsAndEnrichmentCountDto {
    export enum type {
        STATIC = 'STATIC',
        DYNAMIC = 'DYNAMIC',
        AI = 'AI',
    }
}

